import { useQuery } from "@tanstack/react-query";
import { getEditoras } from "../../../api";

const useGetEditoras = (produtoId: number = 1) => {
    const { data, isLoading, isError, error } = useQuery({
        queryKey: ['get_editoras', produtoId],
        enabled: true,
        queryFn: () => getEditoras(produtoId),
        refetchOnWindowFocus: false
    });

    return {
        data,
        isLoading,
        isError,
        error,
    }
};

export default useGetEditoras;